export const c_modal_box_m_align_top_spacer = {
  "name": "--pf-v5-c-modal-box--m-align-top--spacer",
  "value": "0.5rem",
  "var": "var(--pf-v5-c-modal-box--m-align-top--spacer)"
};
export default c_modal_box_m_align_top_spacer;